//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { axiosGet, axiosPost } from '../../axios/axios.js'

export default {
  props: {
    orderAdmittance: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data: function () {
    return {
      loading: false,
      opened: false,

      templates: [],

      selectedTemplateId: null
    }
  },
  watch: {
    opened: function (result) {
      if (!result) {
        this.resetParameters()
      } else {
        this.loadTemplates()
      }
    }
  },
  methods: {
    loadTemplates: function () {
      this.loading = true

      axiosGet({
        url: '/service/delta/orderadmittance/gettemplates',
        onSuccess: (response) => {
          this.templates = response.data

          for (const template of this.templates.values()) {
            if (template.id === this.orderAdmittance.templateId) {
              this.selectedTemplateId = template.id
              break
            }
          }
        },
        onFailure: 'Ошибка загрузки списка шаблонов',
        msgTarget: this
      }).finally(() => {
        this.loading = false
      })
    },
    onClose: function () {
      this.opened = false
    },
    resetParameters: function () {
      this.selectedTemplateId = null
      this.selectedBrigades = []
      this.templates = []
    },
    onSave: function (action) {
      this.loading = true

      const params = new URLSearchParams()
      params.append('orderId', this.orderAdmittance.id)
      params.append('templateId', this.selectedTemplateId)

      const bodyFormData = this.$parent.prepareBodyFormData(this.orderAdmittance.state)

      axiosPost({
        url: '/service/delta/orderadmittance/updateByTemplate?' + params.toString(),
        data: bodyFormData,
        onSuccess: () => {
          this.$emit('update')

          this.$q.notify({
            type: 'positive',
            message: 'Успешное изменение шаблона',
            progress: true,
            timeout: 3000
          })
        },
        onFailure: 'Ошибка при изменении шаблона'
      }).finally(() => {
        this.opened = false
        this.loading = false
      })
    }
  }
}

